import { Scroller, Slider } from '@cian/slider';

import { FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { InvestmentSlide, InvestmentSlideProps } from './internal/components/InvestmentSlide';
import { ArrayOfObjects } from 'shared/types/ArrayOfObjects';
import { SliderButtons } from './internal/components/SliderButtons';

import styles from './InvestmentBlock.css';

export type MediaData = ArrayOfObjects<InvestmentSlideProps>;

type InvestmentBlockProps = {
  id: string;
  title: string;
  media: ArrayOfObjects<InvestmentSlideProps>;
  description: string;
};

export const InvestmentBlock: FC<InvestmentBlockProps> = ({ title, media, id, description }) => {
  return (
    <LayoutBlock id={id} title={title} sectionTabTitle={title} description={description}>
      <Slider loop>
        <Scroller>
          {media.map(slide => (
            <InvestmentSlide
              key={slide.id}
              investorInfo={slide.investorInfo}
              investorShortStory={slide.investorShortStory}
              investorStory={slide.investorStory}
              video={slide.video}
            />
          ))}
        </Scroller>
        <div className={styles['buttons-wrapper']}>
          <SliderButtons />
        </div>
      </Slider>
    </LayoutBlock>
  );
};
